var _rect, _rect2, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 57,
    viewBox: "0 0 45 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 56,
    rx: 1.5,
    fill: "#F0F2F4",
    stroke: "#DCE0E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 30,
    height: 35.7143,
    rx: 0.718002,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.299 19H29.8644C30.5811 19 31.1634 19.5779 31.1634 20.2629V30.4729C31.1634 31.1578 30.5811 31.7144 29.8644 31.7144H14.299C13.5823 31.7144 13 31.1578 13 30.4729V20.2629C13 19.5779 13.5823 19 14.299 19ZM19.9876 21.7826L23.6382 26.5986L25.7211 23.8374L30.2227 29.7879V20.2629C30.2227 20.0488 30.0659 19.899 29.8644 19.899H14.299C14.0974 19.899 13.9182 20.0488 13.9182 20.2629V29.7879L19.9876 21.7826Z",
    fill: "#77848E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 41.1431,
    width: 2.28565,
    height: 1.14283,
    rx: 0.571413,
    fill: "#FF7F33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8574,
    y: 41.1431,
    width: 2.28565,
    height: 1.14283,
    rx: 0.571413,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7148,
    y: 41.1431,
    width: 2.28565,
    height: 1.14283,
    rx: 0.571413,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousel);
export default __webpack_public_path__ + "static/media/carousel.c68f4e2f11e81f1ad2b7379657d17856.svg";
export { ForwardRef as ReactComponent };